/**
 * Назва розділу для вкладки браузера за метаданими маршруту.
 *
 * НАВІЩО. Core (RouteKernelLoader) кладе в метадані маршруту `pageConfig.title`
 * сторінки, але сам `document.title` не змінює. Через це сторінки без власного
 * `document.title = …` (Головна, Звіти, Довідники, Системні події…) лишали у
 * вкладці назву попереднього розділу.
 *
 * Беремо назву лише зі звичайних сторінок контейнерів і лише коли її задано явно:
 *   - resource-маршрути (автогенеровані CRUD) ставлять назву самі через
 *     HeaderPage → SetDocumentTitle, а в метаданих у них технічний ключ
 *     («Transport.TypicalRoute - List»);
 *   - без `pageConfig.title` Core підставляє ім'я компонента («Index», «Profile»),
 *     показувати таке користувачу не можна — такі сторінки задають назву самі.
 */
export interface RouteTitleSource {
    title?: string | undefined
    group?: string | undefined
    componentName?: string | undefined
}

export function resolveRouteTitle(route: RouteTitleSource): string | null {
    if (route.group !== 'container') return null

    const title = route.title?.trim()
    if (!title) return null

    // Фолбек Core: title = componentName без суфікса Page
    const fallback = route.componentName?.replace(/Page$/, '')
    if (fallback && title === fallback) return null

    return title
}
